import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// 布局组件
import MainLayout from '../../widgets/header/Layout/Layout';

// 页面组件导入
import HomePage from '../../pages/Home/HomePage';
import ChatPageNew from '../../pages/Chat/ChatPageNew';
import HistoryPage from '../../pages/History/HistoryPage';
import ProfilePage from '../../pages/Profile/ProfilePage';
import SettingsPage from '../../pages/Settings/SettingsPage';
import PricingPage from '../../pages/Pricing/PricingPage';
import PaymentPage from '../../pages/Payment/PaymentPage';
import RegisterPage from '../../pages/Auth/RegisterPage';
import LoginPage from '../../pages/Auth/LoginPage';
import OAuthCallbackPage from '../../pages/Auth/OAuthCallbackPage';
// 测试页面已删除，移除相关导入
import PaymentResult from '../../pages/Payment/PaymentResult';

const AppRouter: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* ChatPageNew 不使用 MainLayout 包装 */}
        <Route path="/chat" element={<ChatPageNew />} />
        
        {/* 其他页面使用 MainLayout 包装 */}
        <Route path="/*" element={
          <MainLayout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/history" element={<HistoryPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/payment" element={<PaymentPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/auth/oauth/callback" element={<OAuthCallbackPage />} />
              {/* 测试页面路由已删除 */}
              <Route path="/payment/success" element={<PaymentResult />} />
              <Route path="/payment/cancel" element={<PaymentResult />} />
              <Route path="/payment/failure" element={<PaymentResult />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </MainLayout>
        } />
      </Routes>
    </Router>
  );
};

export default AppRouter; 